import { Typography } from '@montugroup/design-system';
import type { StepType } from '@reactour/tour';
import { COLLAPSIBLE_MENU_ICON } from './selectors';

const collapsibleMenu = (handleDismissAlert: () => Promise<void>): StepType[] => [
  {
    selector: `[data-tour-selector='${COLLAPSIBLE_MENU_ICON}']`,
    content: () => (
      <Typography variant="h5">
        Use this icon to <strong>expand</strong> and <strong>collapse</strong> the main navigation menu.
      </Typography>
    ),
    position: [40, 90],
    stepInteraction: true,
    actionAfter: () => handleDismissAlert(),
  },
];

export { collapsibleMenu };
